import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#testimonials" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-dark py-3" : "bg-transparent py-6"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="/logo.png"
            alt="Canopy Grounds logo"
            className="h-9 w-auto"
            style={{ height: "36px" }}
          />
          <span className="font-display text-xl sm:text-2xl tracking-wide text-cream">
            CANOPY <span className="text-gold">GROUNDS</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm uppercase tracking-[0.15em] text-cream/80 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            data-testid="nav-quote-btn"
            className="bg-gold text-ink px-6 py-3 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-gold-hover transition-colors duration-300"
          >
            Free Quote
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-cream"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden glass-dark mt-3 mx-6 p-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.15em] text-cream/90 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            className="bg-gold text-ink px-6 py-3 text-center text-xs font-semibold uppercase tracking-[0.15em]"
          >
            Free Quote
          </a>
        </div>
      )}
    </header>
  );
};
